module.exports = __webpack_public_path__ + "static/media/similMaderaCedro.fd87c972.jpg";